import * as React from 'react';
import { MessageBar, MessageBarType } from 'office-ui-fabric-react/lib/MessageBar';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export const FieldWarningMessage = _ref => {
  let {
    children = null,
    styles
  } = _ref;
  if (!children) return /*#__PURE__*/_jsx(_Fragment, {});
  return /*#__PURE__*/_jsx(MessageBar, {
    messageBarType: MessageBarType.warning,
    isMultiline: true,
    dismissButtonAriaLabel: "Close",
    styles: styles,
    children: children
  });
};